export default {
  buttons: {
    signup: 'Regístrate',
    login: 'Iniciar sesión',
  },
};
